<template>
  <div>
    <div
      class="row flex justify-content-between request-type-selector__container"
      :class="error && 'border border-danger'"
    >
      <div class="col-3 request-type-selector__text title">
        <b :class="error && 'text-danger'">{{ label }}</b>
      </div>
      <div class="col">
        <div class="row">
          <div
            v-for="option in options"
            :key="option.id"
            class="border px-0"
            :class="colClass"
          >
            <div
              class="request-type-selector-option__container d-flex justify-content-center"
            >
              <input
                v-model="model"
                :id="option.id"
                type="radio"
                name="contact"
                :value="option"
                :disabled="disabled"
                :required="required"
              />
              <label
                :for="option.id"
                class="request-type-selector-option__label"
              >
                <i
                  v-if="option.icon"
                  :class="option.icon"
                  class="ml-3 mr-1 color-orange"
                >
                </i>
                <span :class="error && 'text-danger'">{{ option.label }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Error v-if="error" variant="no-border" :message="customErrorMsg" />
  </div>
</template>

<script>
import Error from "@/components/common/Error";
export default {
  name: "TypeSelector",
  components: {
    Error
  },
  props: {
    value: {
      type: Object | null,
      required: true,
      default: () => ({
        id: null,
        label: null,
        name: null,
        icon: null
      })
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: "Estado deshabilitado",
        example: "disabled"
      }
    },
    error: {
      type: String,
      default: "",
      meta: {
        description: "Estado error",
        example: "Texto requerido"
      }
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: "Personalización para mensajes de error",
        example: "Texto requerido"
      }
    },
    required: {
      type: String,
      default: function() {
        return "";
      },
      meta: {
        description: "Estado requerido",
        example: "required"
      }
    }
  },
  data() {
    return {
      model: {
        id: null,
        label: null,
        name: null,
        icon: null
      }
    };
  },
  computed: {
    colClass() {
      return `col-${12 / this.options.length}`;
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newValue) {
        this.model = this.options.find(opt => opt.id == newValue.id);
      }
    },
    model: {
      deep: true,
      handler(newValue) {
        this.$emit("input", newValue);
      }
    }
  }
};
</script>

<style type="scss" scoped>
.request-type-selector__container {
  border-radius: 5px;
}
div.title {
  background-color: #f4f6f3;
}

.request-type-selector__text {
  display: flex;
  align-items: center;
}

.request-type-selector-option__container {
  background-color: #fff;
  border-radius: 2px;
  padding: 25px;
}

.request-type-selector-option__label {
  display: flex;
  align-items: center;
}

input[type="radio"] {
  display: none;
}

input[type="radio"] + label:before {
  content: "";
  display: inline-block;
  width: 23px;
  height: 23px;
  padding: 4px;
  background-clip: content-box;
  border: 2px solid #bbbbbb;
  border-radius: 50%;
}

div.request-type-selector-option__container:has(input[type="radio"]:checked) {
  background-color: #2db782;
  color: white;

  & input[type="radio"] + label:before {
    background-color: #fff;
    border-color: #fff;
  }

  & label > i {
    color: #fff !important;
  }
}

div.request-type-selector-option__container:has(input[type="radio"]:disabled:not(:checked)) {
  background-color: #f7f7f7;
  & input[type="radio"] + label:before {
    background-color: #e2e2e2;
  }
}
</style>
